import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Typography from '../../../components/overrides/Typography';
import {
  NO_SEARCH_RESULT_TITLE,
  NO_SEARCH_RESULT_DESCRIPTION,
  NO_SEARCH_RESULT_CLEAR_CTA,
} from '../../../assets/copy';
import { Button } from '../../../components/spoon/Button';

const useStyles = makeStyles((theme) => ({
  customButton: {
    marginTop: '27px',
    width: '172.5px',
    padding: '9px 16px 11px 16px',
    fontSize: '14px',
    lineHeight: '20px',
    borderRadius: '12px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '12px',
    },
  },
  descriptionText: {
    paddingTop: '4px',
    color: theme.palette.spoon.black[100],
  },
}));

const ClearSearch = ({ clearSearchFunction }) => {
  const classes = useStyles();

  return (
    <div>
      <Typography 
        variant="medium2Light"
        component="h1">
          {NO_SEARCH_RESULT_TITLE}
      </Typography>
      <Typography variant="small3Normal" className={classes.descriptionText}>
        {NO_SEARCH_RESULT_DESCRIPTION}
      </Typography>
      <Button
        classes={{ root: classes.customButton }}
        onClick={clearSearchFunction}>
        {NO_SEARCH_RESULT_CLEAR_CTA}
      </Button>
    </div>
  );
};

export default ClearSearch;
